import './index.css';
import ControlPanel from './ControlPanel';
export default ControlPanel;